import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  // cloudia tenant will be fully renamed to tcp later, for now to risky for production
  static cloudiaLegacyTenantName = 'cloudia';

  addTenantToHeaders(headers: HttpHeaders): HttpHeaders {
    return headers.append('X-CUSTOMER-ID', this.getTenant());
  }

  getTenant() {
    const tenantFromPath = this.getTenantFromPath();
    return tenantFromPath || TenantService.cloudiaLegacyTenantName;
  }

  getTenantFromPath() {
    return window.location.href.replace('//', '').split('/')[1].split('#')[0];
  }
}

export enum Tenant {
  cloudia = 'cloudia',
  'cloudia-customer' = 'cloudia-customer',
}
